import axios from 'axios';
import { fetchEventSource } from '@microsoft/fetch-event-source';

const crsfEl = document.querySelector('meta[name="csrf-token"]');
const csrfToken = crsfEl ? crsfEl.getAttribute('content') : '';

const authorization = import.meta.env.VITE_INTERNAL_PARTNER_API_TOKEN;
const headers = {
  'X-Requested-With': 'XMLHttpRequest',
  'Content-Type': 'application/json',
  Authorization: authorization,
  'X-CSRF-Token': csrfToken,
};

export const fetchEventSourceApi = async (url, options = {}) => {
  const { headers: optionHeaders, ...otherOptions } = options;
  const fetchEventSourceHeaders = { ...headers, ...optionHeaders };

  return fetchEventSource(url, {
    headers: fetchEventSourceHeaders,
    ...otherOptions,
  });
};

export const api = axios.create({
  headers,
});

export const get = async (url, params) => {
  const { data } = await api.get(url, { params });
  return data;
};

export const getPaginated = baseUrl => (
  page,
  limit,
  sortBy,
  sortDirection,
  filter,
) => {
  const basePaginated = `${baseUrl}?page=${page}&limit=${limit}&filter=${filter}`;

  return sortBy
    ? get(`${basePaginated}&sort_by=${sortBy}&sort_direction=${sortDirection}`)
    : get(basePaginated);
};

export const getAll = baseUrl => (sortBy, sortDirection, filter) =>
  sortBy
    ? get(
        `${baseUrl}?filter=${filter}&sort_by=${sortBy}&sort_direction=${sortDirection}`,
      )
    : get(baseUrl, { filter });
